module.exports = __webpack_public_path__ + "media/images/area/sub_hero_map_kanagawa-ff484712c08ba7126633a499d09ca8f1.png";